var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
import { Header } from "../components/particals/header/Header";
import { ScrollToTop } from "../../utils/components/ScrollToTop";
import { Footer } from "../components/particals/footer/Footer";
export var MainLayout = function () { return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "application" }, { children: [_jsx(Header, {}), _jsxs("div", __assign({ className: "container" }, { children: [_jsx(ScrollToTop, {}), _jsx(Outlet, {})] })), _jsx(Footer, {})] })) })); };
